/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_CompanyInputs */

const en_user_company = /** @type {(inputs: User_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const ja_user_company = /** @type {(inputs: User_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会社`)
};

const fr_user_company = /** @type {(inputs: User_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entreprise`)
};

const de_user_company = /** @type {(inputs: User_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen`)
};

/**
* | output |
* | --- |
* | "Company" |
*
* @param {User_CompanyInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_company = /** @type {((inputs?: User_CompanyInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_CompanyInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_company(inputs)
	if (locale === "ja") return ja_user_company(inputs)
	if (locale === "fr") return fr_user_company(inputs)
	return de_user_company(inputs)
});